import { Box, CircularProgress } from '@mui/material';

const Loader = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 120 }}>
    <CircularProgress color="primary" />
  </Box>
);

export default Loader; 
